import * as cookie from 'js-cookie';

interface NextJSProcess extends NodeJS.Process {
  browser: boolean;
}

export const isBrowser: boolean = process
  ? (process as NextJSProcess).browser
  : typeof window !== 'undefined';

const getCookieFromBrowser = (key: string) => cookie.get(key);

// tslint:disable-next-line: no-any
const getCookieFromServer = (key: string, req: any) => {
  if (!req || !req.headers.cookie) {
    return undefined;
  }

  const rawCookie = req.headers.cookie
    .split(';')
    .find((c: string) => c.trim().startsWith(`${key}=`));

  if (!rawCookie) {
    return undefined;
  }

  return rawCookie.split('=')[1];
};

// tslint:disable-next-line: no-any
export const getCookie = (key: string, req?: any) =>
  isBrowser ? getCookieFromBrowser(key) : getCookieFromServer(key, req);

// tslint:disable-next-line: no-any
export const setCookie = (key: string, value: any, res?: any) => {
  if (!isBrowser) {
    if (res) {
      res.setHeader('Set-Cookie', `${key}=${value}; path=/;`);
    }
    return;
  }
  cookie.set(key, value, {
    expires: 7, // 7 days. refs: https://github.com/js-cookie/js-cookie#expires
    path: '/',
  });
};

export const removeCookie = (key: string) => {
  if (!isBrowser) {
    return;
  }
  cookie.remove(key, {
    expires: 1,
  });
};
